<template>

<div class="inner">

	<div v-if="html" v-html="html"></div>

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['html']

}

</script>

<style scoped>

.inner {
	max-width: 1200px;
	width: 100%;
	margin: 0px auto;
}

</style>